import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import KivaProxy from "@/utils/kivaProxy/src";
import { FieldOptionTransformer } from "@/transformers/FieldOptionTransformer";
import { CrmAccountTransformer } from "@/transformers/CrmAccountTransformer";
import { makeNest } from "@/utils/makeNest";
import { InboxCategoryTransformer } from "@/transformers/InboxCategoryTransformer";
import { TeamTransformer } from "@/transformers/TeamTransformer";
import { USERS } from "@/store/modules/users/mutation-types";
import { mapGetters, mapState } from "vuex";
import KvAccountMemberSelect from "@/components/kiva/KvAccountMemberSelect";
import { inboxThreadModel } from "@/models/inboxThreadModel";
import { inboxMessageModel } from "@/models/inboxMessageModel";
import { InboxMessageTransformer } from "@/transformers/InboxMessageTransformer";
import { ThreadTransformer } from "@/transformers/ThreadTransformer";
import KvModal from "@/components/kiva/KvModal";
import ReplyDrawer from "@/views/inbox/components/ReplyDrawer";
import KvSvgIcon from "@/components/kiva/kvSvgIcon.vue";
import { temporaryImageUpload, temporaryImageBase64 } from "@/utils/temporaryImageUpload";
import thredMixin from "@/mixins/thread";
import optionsMixin from "@/mixins/options";
import labelMixin from "@/mixins/labels";
import moment from "moment";
var requests = require("@/utils/requests").default;
import kvLabelInput from "@/components/kiva/input/kvLabelInput";
import { TEAMS } from "@/store/modules/team/mutation-types";
import KvAvatar from "@/components/kiva/KvAvatar";
import KvAttachmentList from "@/components/kiva/KvAttachmentList";
export default {
  name: "InboxModal",
  mixins: [thredMixin, optionsMixin, labelMixin],
  components: {
    KvModal: KvModal,
    kvSelection: function kvSelection() {
      return import("@/components/kiva/remote-search/kvSelection");
    },
    KvAccountMemberSelect: KvAccountMemberSelect,
    kvLabelInput: kvLabelInput,
    KvAvatar: KvAvatar,
    KvAttachmentList: KvAttachmentList,
    ReplyDrawer: ReplyDrawer,
    KvSvgIcon: KvSvgIcon,
    kvContacts: function kvContacts() {
      return import("@/components/kiva/remote-search/kvContactsFeatured");
    },
    kvContactsEmail: function kvContactsEmail() {
      return import("@/components/kiva/remote-search/kvContactsEmail");
    },
    kvAccount: function kvAccount() {
      return import("@/components/kiva/remote-search/kvAccountsFeatured");
    },
    KvProject: function KvProject() {
      return import("@/components/kiva/remote-search/kvProject");
    },
    CounterActionButton: function CounterActionButton() {
      return import("@/components/Items/TimeCounter/CounterActionButton");
    },
    timeEntry: function timeEntry() {
      return import("@/components/tasks/timeEntry/timeEntryForm");
    },
    KvSection: function KvSection() {
      return import("@/components/kiva/remote-search/kvSection");
    }
  },
  props: {
    value: {
      type: Boolean
    },
    data: {},
    editPermissionProps: {
      type: Boolean,
      default: false
    },
    pushData: {}
  },
  // inject: ['inbox'],
  data: function data() {
    return {
      loading: false,
      mutableValue: this.value,
      messages: null,
      isForward: false,
      excerpt: "",
      editPermission: this.editPermissionProps,
      sendMessageAction: false,
      reply: null,
      activeNames: null,
      modalKey: null,
      incomingChannels: [],
      isNewContact: false,
      skey: "skey" + Math.random(9, 999),
      accounts: [],
      sla: [],
      slaLevels: [],
      slaLevelsTotal: 0,
      contactKeys: "contactKeys",
      model: inboxThreadModel(),
      messageModel: inboxMessageModel(),
      editorConfig: {
        toolbarExternal: "#editor-toolbar",
        focus: true,
        disabled: true,
        disable: true,
        imageUpload: temporaryImageUpload
      },
      editorConfig2: {
        toolbarExternal: "#editor-toolbar2",
        focus: true,
        imageUpload: temporaryImageUpload
      },
      timeEntry: {
        selected: {},
        show: false,
        key: "keyTE",
        list: [],
        listKey: "listKeyTE"
      },
      formOpen: {
        account: false,
        contact: false
      },
      defaultNewAccount: {},
      defaultNewContact: {}
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var f;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.initData();
            _this.messageModel = inboxMessageModel({});
            if (!_this.data) {
              _this.model = inboxThreadModel({
                recordOwner: _objectSpread({}, _this.getCurrentUser),
                team: {
                  teamId: _this.getCurrentUser.primaryTeam
                },
                incomingChannel: {
                  value: 2
                }
              });
            } else {
              _this.list_time_entries(_this.data.id, null, 1);
            }
            if (_this.pushData && _this.pushData.app == "inbox" && _this.pushData.model == "thread") {
              _this.model.messageModel = _this.pushData.subject;
              _this.list_time_entries(_this.pushData.record_id, null, 1);
            }
            if (!(_this.pushData && _this.pushData.attachment && _this.pushData.app == "inbox" && _this.pushData.model == "thread")) {
              _context.next = 9;
              break;
            }
            _context.next = 7;
            return temporaryImageBase64(_this.pushData.attachment);
          case 7:
            f = _context.sent;
            _this.messageModel.message = "<figure><img src=\"".concat(f, "\" /></figure> ");
            //  this.model.messageModel = temporaryImageUpload(this.pushData.attachment);
            //  <figure>
          case 9:
            _this.mutableValue = true;
            console.log("messageModel", _this.pushData, _this.data, _this.mutableValue, _this.templatePopup.show);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    handleReply: function handleReply(message) {
      this.isForward = false;
      this.excerpt = "".concat(this.inboxPreferences.signatureTemplate, "<br><p>---------------------------------------------</p>").concat(message.message);
      this.sendMessageAction = true;
    },
    handleForward: function handleForward(message) {
      this.isForward = true;
      this.excerpt = "".concat(message ? message.message : "", "<br><p>---------------------------------------------</p>").concat(this.inboxPreferences.signatureTemplate);
      this.sendMessageAction = true;
    },
    getMessages: function getMessages() {
      var _this2 = this;
      // console.log("Get messages start");
      this.loading = true;
      new KivaProxy({
        endpoint: "inbox/message",
        parameters: {
          getAtc: 1
        }
      }).setFields(["ticket_id", "thread", "message_no", "record_owner", "message", "stripped_message", "sender", "send_date", "draft", "sender_contact", "sender_name", "sender_email", "sender_phone", "created_on", "created_by", "last_modified_on"]).setFilters({
        thread: ["=", this.id]
      }).all().then(function (response) {
        _this2.loading = false;
        _this2.messages = response.records;
        // debugger
        _this2.reply = response.records[0] && response.records[0].message ? response.records[0].message : "";
        if (response.records[0]) {
          _this2.activeNames = [response.records[response.records.length - 1].record_id];
        }
        _this2.modalKey = Math.random(9, 9999);
      });
    },
    WorkPermission: function WorkPermission() {
      if (this.model.recordOwner && this.model.recordOwner.value && this.model.recordOwner.value == this.$store.state.users && this.$store.state.users.CURRENT_USER && this.$store.state.users.CURRENT_USER.userId ? this.$store.state.users.CURRENT_USER.userId : null) {
        return true;
      }
    },
    list_time_entries: function list_time_entries(record_id, record_owner, status) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var search, time_entries;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.timeEntry.list = [];
              search = {};
              if (record_id) {
                search.thread = record_id;
              }
              if (record_owner) {
                search.record_owner = record_owner;
              }
              if (status) {
                search.status = status;
              } else {
                search.status = 1;
              }
              // console.log("list_time_entries",record_id,search)
              _context2.next = 7;
              return requests.get_time_entry(search);
            case 7:
              time_entries = _context2.sent;
              _this3.timeEntry.list = time_entries.records;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    total_time: function total_time(owner) {
      if (owner == "my") {
        owner = this.$store.state.users.CURRENT_USER ? this.$store.state.users.CURRENT_USER.userId : null;
      }
      var all = this.timeEntry.list;
      var total = 0;
      if (all && _typeof(all) == "object") {
        all.forEach(function (e) {
          if (owner) {
            if (owner == e.record_owner.value) {
              var h = e.hours * 60;
              var m = e.minutes;
              total += h + m;
            }
          } else {
            var _h = e.hours * 60;
            var _m = e.minutes;
            total += _h + _m;
          }
        });
      }
      var to = Math.floor(total / 60);
      var mi = total - to * 60;
      var ho = to ? to + "s " : "";
      var min = mi ? mi + "dk. " : "";
      return ho + " " + min;
    },
    showTimeEntryForm: function showTimeEntryForm() {
      // this.timeEntry.selected = {
      //   project: this.model.project ? this.model.project.value : "",
      //   thread: this.model.record_id ? this.model.record_id : "",
      //   task: null,
      //   event: null,
      // };
      // this.timeEntry.show = !this.timeEntry.show;
      // this.timeEntry.key = Math.random(100, 9999);

      this.$store.dispatch("app/activateDrawer", {
        show: true,
        tab: "logTimeEntry",
        options: {
          data: {
            thread: {
              value: this.model.record_id,
              label: this.model.subject
            },
            project: this.model.project
          }
        }
      });
    },
    initData: function initData() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.getThread();
            case 2:
              _context3.next = 4;
              return Promise.all([_this4.getMessages(), _this4.getIncomingChanngels(), _this4.getOptions({
                app: "inbox",
                model: "thread",
                column: "case_status"
              }), _this4.getOptions({
                app: "inbox",
                model: "thread",
                column: "priority"
              }), _this4.getInboxCategory({
                app: "inbox",
                model: "category",
                column: "all"
              }), _this4.getOptions({
                app: "inbox",
                model: "thread",
                column: "request_type"
              }), _this4.getOptions({
                app: "inbox",
                model: "thread",
                column: "request_status"
              }), _this4.getOptions({
                app: "inbox",
                model: "thread",
                column: "sales_inquiry_status"
              })]);
            case 4:
              _this4.getSla();
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getSla: function getSla() {
      var _this5 = this;
      new KivaProxy({
        endpoint: "inbox/sla"
      }).all().then(function (response) {
        // this.slaTotal = response.total;
        _this5.sla = response.records.map(function (k) {
          return {
            value: k.record_id,
            label: k.sla_name
          };
        });
        // this.setDefaultSla();
        _this5.getSlaLevels();
      });
    },
    getSlaLevels: function getSlaLevels() {
      var _this6 = this;
      var sla = this.model.sla && this.model.sla.value ? this.model.sla.value : null;
      if (sla) {
        new KivaProxy({
          endpoint: "inbox/sla_level_configuration"
        }).setFilters({
          sla: ["=", sla]
        }).all().then(function (response) {
          _this6.slaLevelsTotal = response.total;
          _this6.slaLevels = response.records.map(function (k) {
            return {
              value: k.record_id,
              label: k.sla_level.label
            };
          });
          // this.setDefaultSlaLevel();
        });
      }
    },
    checkCategoryStatus: function checkCategoryStatus() {
      var _this7 = this;
      var val = this.model.category;
      if (this.model.category) {
        var found = {};
        this.options["inbox_category_all"].forEach(function (k) {
          if (k.recordId == val) {
            found = k;
            return k;
          }
          k.children.forEach(function (c) {
            if (c.recordId == val) {
              found = c;
              return c;
            }
          });
        });
        if (found.slaLevel && found.slaLevel.value && found.slaLevel.value != null) {
          this.model.slaLevel = found.slaLevel;
        }
        if (found.requestType.label) {
          var old = this.model.requestType ? this.model.requestType.label : "";
          if (this.model.requestType.value != found.requestType.value) {
            this.$confirm(this.$t("Due to category change the type of this case will be updated from ") + old + this.$t(" to ") + found.requestType.label + this.$t(" Do you approve this action?"), this.$t("Warning"), {
              confirmButtonText: this.$t("OK"),
              cancelButtonText: this.$t("Cancel"),
              type: "warning"
            }).then(function () {
              _this7.model.requestType = found.requestType;
              _this7.save();
            });
          }
        }
      }
    },
    openModal: function openModal(data) {
      this.$store.state.app.templatePopup.data = {
        record_id: null,
        model: "inboxCategory",
        openSearchBox: false
      };
      this.$store.state.app.templatePopup.show = true;
    },
    getIncomingChanngels: function getIncomingChanngels() {
      var _this8 = this;
      new KivaProxy({
        endpoint: "inbox/thread/incoming_channel/options"
      }).all().then(function (response) {
        _this8.incomingChannels = FieldOptionTransformer.fetchCollection(response.records);
      });
    },
    getThread: function getThread() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_this9.pushData && _this9.pushData.record_id)) {
                _context4.next = 4;
                break;
              }
              _this9.loading = true;
              _context4.next = 4;
              return new KivaProxy({
                endpoint: "inbox/thread"
              }).setFields(["message_status", "thread_id", "raw_message_id", "message_count", "brand", "subject", "sender", "incoming_channel", "case_status", "category", "star", "priority", "closed_on", "follow_up_on", "team", "record_owner", "assigned_to_photo", "account_name", "last_message_date", "contact_name", "last_message", "project", "sender_name", "sender_email", "sender_phone", "cc", "bcc", "solution", "followers", "notify_on", "hold_reason", "notify_msg", "sla", "sla_level", "app_account_id", "app_user_id", "first_assigned_time", "time_since_last_reply", "created_on", "created_by", "last_modified_on", "last_modified_by", "request_type", "request_status", "estimated_start_date", "estimated_delivery_date", "estimated_effort", "sales_inquiry_status", "rel_contact_name_email", "rel_contact_name_mobile", "sla", "sla_level", "sla_remaining_time_calculated", "section"]).find(_this9.pushData.record_id).then(function (response) {
                console.log("response", _this9.pushData.record_id);
                _this9.list_time_entries(_this9.pushData.record_id, null, 1);
                _this9.model = ThreadTransformer.fetch(response.record);
                _this9.loading = false;
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var d, threadProxy;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              console.log("save", _this10.isEdit);
              if (!_this10.isEdit) {
                _context5.next = 7;
                break;
              }
              d = ThreadTransformer.send(_this10.model);
              _this10.$store.commit("savingStart", {
                status: 1
              });
              threadProxy = new KivaProxy({
                endpoint: "inbox/thread"
              });
              _context5.next = 7;
              return threadProxy.update([d]).then(function (k) {
                _this10.$store.commit("savingEnd", {
                  status: 2,
                  result: {
                    app: "inbox",
                    modul: "thread",
                    recordId: k.record_id
                  }
                });
              }).catch(function (err) {
                _this10.$store.commit("savingEnd", {
                  status: 3,
                  result: {
                    app: "inbox",
                    modul: "thread",
                    recordId: ""
                  }
                });
                console.log("err", err);
              });
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    createOrEditThread: function createOrEditThread(status) {
      var _this11 = this;
      this.$validator.validateAll().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(response) {
          var method, threadProxy, contact, d;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (!response) {
                  _context6.next = 13;
                  break;
                }
                method = "create";
                threadProxy = new KivaProxy({
                  endpoint: "inbox/thread"
                });
                if (_this11.isEdit) {
                  method = "update";
                }
                if (!_this11.isNewContact) {
                  _context6.next = 9;
                  break;
                }
                if (!_this11.model.newContact) {
                  _context6.next = 9;
                  break;
                }
                contact = {
                  record_id: null,
                  firstname: _this11.model.newContact.firstname,
                  lastname: _this11.model.newContact.lastname,
                  phone: _this11.model.newContact.phone,
                  email: _this11.model.newContact.email,
                  account_name: _this11.model.newContact.account_name.record_id
                };
                _context6.next = 9;
                return new KivaProxy({
                  endpoint: "crm/contact"
                }).create(contact).then(function (response) {
                  var res = response.records[0];
                  _this11.model.contactName = {};
                  _this11.model.contactName.id = res.record_id;
                  _this11.model.contactName.recordId = res.record_id;
                  _this11.model.accountName = _this11.model.newContact.account_name;
                  // this.model.senderEmail = contact.email;
                  // this.model.senderName = `${contact.firstname} ${contact.lastname}`;
                  // this.model.senderPhone = contact.phone;
                  var me = _this11.me;
                  _this11.messageModel.senderEmail = contactName.email;
                  _this11.messageModel.senderName = contactName.name;
                  _this11.messageModel.senderPhone = me.phone;
                  _this11.$store.state.lastUpdate = {
                    app: "inbox",
                    model: "thread",
                    id: res.record_id,
                    work: "create",
                    time: moment().valueOf(),
                    data: res
                  };
                  _this11.$store.state.lastUpdate.time = moment().valueOf();
                });
              case 9:
                d = ThreadTransformer.send(_this11.model);
                _this11.$store.commit("savingStart", {
                  status: 1
                });
                _context6.next = 13;
                return threadProxy[method]([d]).then(function (response) {
                  _this11.$store.commit("savingEnd", {
                    status: 2,
                    result: {
                      app: "inbox",
                      modul: "thread",
                      recordId: ""
                    }
                  });
                  var record_id = response.records[0].record_id;
                  _this11.$store.state.lastUpdate = {
                    app: "inbox",
                    model: "thread",
                    id: response.records[0].record_id,
                    work: "update",
                    time: moment().valueOf(),
                    data: response.records[0]
                  };
                  _this11.$store.state.lastUpdate.time = moment().valueOf();
                  if (!_this11.isEdit) {
                    _this11.messageModel.thread = response.records[0].record_id;
                    _this11.messageModel.strippedMessage = _this11.messageModel.message ? _this11.$refs.redactor.getStrippedContent() : "";
                    _this11.messageModel.sendDate = new Date();
                    _this11.messageModel.senderContact = _this11.model.contactName;
                    var me = _this11.me;
                    _this11.messageModel.senderEmail = _this11.model.contactName.email;
                    _this11.messageModel.senderName = _this11.model.contactName.name;
                    new KivaProxy({
                      endpoint: "inbox/message"
                    }).create([InboxMessageTransformer.send(_this11.messageModel)]).then(function (response) {
                      _this11.model = inboxThreadModel({
                        recordOwner: _objectSpread({}, _this11.getCurrentUser),
                        team: {
                          teamId: _this11.getCurrentUser.primaryTeam
                        }
                      });
                      _this11.$emit("success");
                      _this11.mutableValue = status;
                    });
                  } else {
                    _this11.$emit("success");
                    _this11.saveUncordedLabels(record_id, "inbox", "thread", _this11.unRecordedLabels);
                    _this11.mutableValue = status;
                  }
                }).catch(function (err) {
                  _this11.$store.commit("savingEnd", {
                    status: 3,
                    result: {
                      app: "inbox",
                      modul: "thread",
                      recordId: ""
                    }
                  });
                  console.log("err", err);
                });
              case 13:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    isEdit: function isEdit() {
      return !!this.data || this.pushData && !!this.pushData.record_id;
    },
    me: function me() {
      return _objectSpread({}, this.$store.state.users.CURRENT_USER);
    },
    lastUpdate: {
      get: function get() {
        return this.$store.state.lastUpdate;
      },
      set: function set(val) {
        this.$store.state.lastUpdate = val;
      }
    },
    id: function id() {
      return this.model.threadId;
    }
  }, mapState("users", {
    users: USERS
  })), mapState("teams", {
    teams: TEAMS
  })), mapGetters("users", ["getCurrentUser"])), mapGetters("common", ["inboxPreferences"])), {}, {
    templatePopup: function templatePopup() {
      return this.$store.state.app.templatePopup;
    }
  }),
  watch: {
    "lastUpdate.time": function lastUpdateTime(val) {
      this.list_time_entries(this.model.threadId, null, 1);
      // this.list_time_entries(this.pushData.record_id, null, null,'TASK');
    },
    value: function value(val) {
      this.mutableValue = val;
      this.skey = "s" + Math.random(9, 99999);
    },
    mutableValue: function mutableValue(val) {
      if (!val) {
        this.$emit("close");
        this.$store.state.app.templatePopup.data = {
          record_id: null,
          name: ""
        };
        this.model = inboxThreadModel();
        this.messageModel = inboxMessageModel();
      }
      this.$emit("input", val);
      this.skey = "s" + Math.random(9, 99999);
    },
    "templatePopup.show": function templatePopupShow(val) {
      if (!this.templatePopup.showView) {
        this.getInboxCategory();
        this.skey = "s" + Math.random(9, 99999);
      }
    },
    "pushData.record_id": function pushDataRecord_id(val) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this12.getThread();
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    data: {
      immediate: true,
      handler: function handler(val) {
        this.model = inboxThreadModel(val);
        this.messageModel = inboxMessageModel(val);
      }
    }
  }
};